import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { decamelize } from './util';
import { printThisObjectClickable } from './util';
import store from './store';

class CrOutput extends Component {    
    constructor(props) {
        super(props);
        this.resultData = this.props.qryOutput.responseParams;
        this.detailResult = this.resultData.detail;
        this.state = {};
    }    

    render(){
        this.resultData = this.props.qryOutput.responseParams;
        this.detailResult = this.resultData.detail;
    return (
        <div id={`${this.props.qryInput.qryType.toLowerCase()}Output`} className={`outputData ${this.props.qryInput.qryType.toLowerCase()}Output`}>
            {/* <Grid className={`primaryOutput`}>  
                {
                    Object.keys(this.resultData).map((item)=>{
                        if(item!=='detail'){
                            return (
                                <Grid.Row className={`outputList-row`} columns={3}>
                                    <Grid.Column className="keyName" width={5}>{decamelize(item)}</Grid.Column>
                                    <Grid.Column width={1}></Grid.Column>
                                    <Grid.Column className="keyValue" width={10}>{this.resultData[item]}</Grid.Column>
                                </Grid.Row>
                            )
                        } 
                    })
                }
            </Grid> */}
            <Grid className={`primaryOutput`} columns={3}>
                {
                   (this.detailResult && this.detailResult.records) ? this.detailResult.records.map((item)=>(
                         <React.Fragment>
                            <Grid.Row className={`outputList-row blueBorder bottom ${this.props.qryInput.qryType}`} columns={1}>
                                <Grid.Column className="keyValue cr-heading" width={10}>{item.name}</Grid.Column>
                            </Grid.Row>
                            {
                                item.values && item.values.sort((a,b)=>{
                                    if(a.key=='city'&&b.key=='street')return 1;
                                    if(b.key=='city'&&a.key=='street')return -1;
                                    if(a.key=='zip'&&b.key=='city')return 1;
                                    if(b.key=='zip'&&a.key=='city')return -1;
                                    return 1;
                                    }).map((_item)=>(
                                    <Grid.Row className={`outputList-row`} key={'xajkkkaa'+_item.key}>
                                        <Grid.Column className="keyName" width={5}>{decamelize(_item.key)}</Grid.Column>
                                        <Grid.Column width={1}></Grid.Column>
                                        <Grid.Column className="keyValue" width={10}>{printThisObjectClickable(_item.value,'xajkkkaa'+_item.key,this )}</Grid.Column>
                                    </Grid.Row>
                                ))
                            }
                         </React.Fragment>
                    )) :<React.Fragment>
                            {
                                (Object.keys(this.resultData)).map((keyyy,iiii)=>(
                                    <Grid.Row key={iiii+"abc"+keyyy} className={`outputList-row`}>
                                        <Grid.Column className="keyName" width={7}>{decamelize(keyyy).replaceAll(/ json$/gi," details")}</Grid.Column>
                                        <Grid.Column width={1}></Grid.Column>
                                        <Grid.Column className="keyValue" width={7}>{printThisObjectClickable(this.resultData[keyyy],iiii+"abc"+keyyy,this)}</Grid.Column>
                                    </Grid.Row>
                                ))
                            }
                    </React.Fragment>
                } 
            </Grid>
        </div>
    )
            }
}

const mapDispatchToProps = {
    
}

const mapStateToProps = (state, props) => {
   console.log("mapStateToProps===", store.getState());
    let _state = store.getState().QryInput || state.QryInput
    return ({
        requestId: _state.requestid,
        mockResponseRequired: _state.mockResponseRequired,
        loading: _state.loading,
        qryInput: _state.qryInput,
        qryOutput: _state.qryOutput,
        saveTo: _state.saveTo
    })
}

export default connect(
mapStateToProps,
mapDispatchToProps
)(CrOutput)